import { render, staticRenderFns } from "./videoSecurity.vue?vue&type=template&id=130a9037&scoped=true&"
import script from "./videoSecurity.vue?vue&type=script&lang=js&"
export * from "./videoSecurity.vue?vue&type=script&lang=js&"
import style0 from "./videoSecurity.vue?vue&type=style&index=0&id=130a9037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a9037",
  null
  
)

export default component.exports